/* eslint-disable */
"use strict";

import ODToggle from "./../../components/toggle.js";
import { ODUtil } from "./../../components/util.js";

var ODLayoutHeaderTopbar = function() {
    // Private properties
	var _toggleElement;
    var _toggleObject;

    // Private functions
    var _init = function() {
			_toggleObject = new ODToggle(_toggleElement, ODUtil.getBody(), {
				targetState: 'topbar-mobile-on',
				toggleState: 'active',
			});
    }

    // Public methods
	return {
		init: function(id) {
            _toggleElement = ODUtil.getById(id);

			if (!_toggleElement) {
                return;
            }

            // Initialize
            _init();
		},

        getToggleElement: function() {
            return _toggleElement;
        }
	};
}();

// Webpack support
if (typeof module !== 'undefined') {
	// module.exports = ODLayoutHeaderTopbar;
}

export default ODLayoutHeaderTopbar;
